(function () {
    'use strict';
    var controllerId = 'profiloOreAdd';
    angular.module('app').controller(controllerId, ['$scope', '$uibModalInstance', '$filter', 'datacontext', 'common', 'profiloOre', '$translate', profiloOreAddFn]);

    function profiloOreAddFn($scope, $uibModalInstance, $filter, datacontext, common, profiloOre, $translate) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');

        //Gestione date
        $scope.open = function ($event) {
            $event.preventDefault();
            $event.stopPropagation();

            $scope.opened = !$scope.opened;
        };
        $scope.dateOptions = {
            formatYear: 'yy',
            startingDay: 1
        };

        $scope.format = 'dd/MM/yyyy';


        $scope.profiloOre = profiloOre;
        if ($scope.profiloOre.Id == 0) {   // sono nel nuovo
            $scope.Titolo = $translate.instant('Nuovo Profilo Orario');
        }
      /*  else {  // sono in modifica
            $scope.Titolo = 'Modifica Costo';
        }*/

        $scope.ok = function (isValid) {
            if (isValid) {
                var result = {};
                if ($scope.profiloOre.Id == 0) { // sono nel nuovo
                    addItem($scope.profiloOre).then(function (result) {
                        if (result.Id && result.Id > 0)
                            $uibModalInstance.close(result);
                    });
                }
                /*else {  // sono in modifica
                    editItem($scope.costiBase).then(function (result) { // metto in result l'oggetto tornato dal server a seguito dell'aggiornamento (può essere nullo se non va a buon fine)
                        if (result.Id && result.Id > 0)
                            $uibModalInstance.close(result);
                    });
                }*/
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        // Modifica elemento
     /*   function editItem(item) {
            return datacontext.costiBase_update(item).then(function (data) {
                if (data == '300') {
                    logError("Team esistente per l'anno " + item.Anno);
                    return null;
                }

                if (!data || data.Id == null || data.Id == 0) {
                    logError("Errore durante la creazione del dato");            // In questo caso l'aggiunta non è andata a buon fine
                    return null;
                }
                return data;                                                    // altrimenti torna l'oggetto modificato
            });
        }*/

        // Aggiunta elemento
        function addItem(item) {
            return datacontext.profiloOre_add(item).then(function (data) {
                
                if (!data || data.Id == null || data.Id == 0) {
                    logError($translate.instant('Errore durante la creazione del dato'));            // In questo caso l'aggiunta non è andata a buon fine
                    return null;
                }

                return data;                                                     // altrimenti torna il nuovo oggetto
            });
        }
    }
})();